// extracted by mini-css-extract-plugin
export var body = "_dq-0";
export var sectionHeader = "_dq-4";
export var shortcutColumns = "_dq-2";
export var shortcutList = "_dq-1";
export var shortcutSection = "_dq-3";